import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFieldUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 18 13",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.625 1.5a4.877 4.877 0 00-4.869 4.628.75.75 0 01-.564.69 2.252 2.252 0 00.558 4.432h1.5a.751.751 0 010 1.5h-1.5A3.75 3.75 0 010 9c0-1.56.952-2.895 2.304-3.457a6.376 6.376 0 0111.79-2.445 4.874 4.874 0 01-.969 9.652h-.375a.751.751 0 010-1.5h.375A3.373 3.373 0 0016.5 7.875a3.381 3.381 0 00-2.972-3.352.755.755 0 01-.576-.398A4.879 4.879 0 008.625 1.5zM8.47 5.468a.75.75 0 011.06 0l2.25 2.25a.75.75 0 11-1.06 1.065l-.97-.975V12a.751.751 0 01-1.5 0V7.808l-.97.974a.75.75 0 11-1.06-1.064l2.25-2.25z",
		fillRule: "evenodd"
	})
});
export default SvgFieldUpload;
